import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Iletisim.css';
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaClock, FaMapMarkerAlt } from "react-icons/fa";

const Iletisim = () => {
  return (
    <div className="iletisim">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="iletisim-hero">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="hero-content">
              <h1>İletişim</h1>
              <p>Kaliteli mobilya ve beyaz eşya çözümleri ile evinizi güzelleştirin</p>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="map-section">
          <div className="container">
            <div className="section-header">
              <h2>Konum</h2>
              <p>Mağazamızı ziyaret etmek için aşağıdaki haritayı kullanabilirsiniz</p>
            </div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d187.96217554524273!2d28.928462930955583!3d41.08221963191249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab0b804d49cdf%3A0xd4d5c4a08d9deb39!2sBALCI%20MOB%C4%B0LYA!5e0!3m2!1str!2str!4v1756487584653!5m2!1str!2str"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Balcı Mobilya Konum"
              ></iframe>
            </div>
          </div>
        </section>


        {/* Contact Info Section */}
          <div className="container">
            <div className="contact-grid">
              
              {/* Phone */}
              <div className="contact-card">
                <div className="contact-icon">
                  <FaPhoneAlt />
                </div>
                <div className="contact-details">
                  <h3>Telefon</h3>
                  <a href="tel:+902126251815" className="contact-link">
                    +90 212 625 1815
                  </a>
                  <a href="tel:+902126250334" className="contact-link">
                    +90 212 625 0334
                  </a>
                  <a href="tel:+902126250457" className="contact-link">
                    +90 212 625 0457
                  </a>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="contact-card">
                <div className="contact-icon whatsapp">
                  <FaWhatsapp />
                </div>
                <div className="contact-details">
                  <h3>WhatsApp</h3>
                  <a 
                    href="https://wa.me/905496250335" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="contact-link"
                  >
                    +90 549 625 0335
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="contact-card">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div className="contact-details">
                  <h3>E-posta</h3>
                  <a style={{ fontSize: '0.9rem' }} href="mailto:balciaksemsettin.bellona@karavil.com.tr" className="contact-link">
                    balciaksemsettin.bellona@karavil.com.tr
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="contact-card">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-details">
                  <h3>Adres</h3>
                  <p className="contact-text">
                    Akşemsettin, Cengiz Topel Cd. No: 13<br />
                    Eyüpsultan / İstanbul
                  </p>
                </div>
              </div>

              {/* Address */}
              <div className="contact-card working-hours-card">
                <div className="contact-icon">
                  <FaClock />
                </div>
                <div className="contact-details">
                  <h3>Çalışma Saatleri</h3>
                  <div className="hours-grid">
                    <div className="hours-item">
                      <span className="day">Hafta İçi :</span>
                      <span className="time">09:00 - 21:00</span>
                    </div>
                    <div className="hours-item">
                      <span className="day">Pazar</span>
                      <span className="time">11:00 - 20:00</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        {/* Store Section */}
        <section className="store-section">
          <div className="container">
            <div className="section-header">
              <h2>Mağazamızdan Bir Kare</h2>
              <p>35 yıllık deneyimimizle modern ve konforlu mağaza atmosferinde sizleri ağırlıyoruz</p>
            </div>
            <div className="store-image-container">
              <div className="store-image">
                <img src="../files/balci-mobilya-ic.jpeg" alt="Balcı Mobilya Mağaza İçi" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Iletisim; 